import { render, staticRenderFns } from "./BrowseRow.vue?vue&type=template&id=201bcd2a&scoped=true&"
import script from "./BrowseRow.vue?vue&type=script&lang=js&"
export * from "./BrowseRow.vue?vue&type=script&lang=js&"
import style0 from "./BrowseRow.vue?vue&type=style&index=0&id=201bcd2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201bcd2a",
  null
  
)

export default component.exports